export enum OnboardingFocusKeys {
  Default = "ONBOARDING:DEFAULT",
  PrivacyPolicy = "ONBOARDING:PRIVACYPOLICY",
  PrivacySettings = "ONBOARDING:PRIVACYSETTINGS",
}
